import {
  ERROR_CODES_ENGLISH,
  ERROR_CODES_THAI,
  ERROR_CODES_CHINESE,
  LANGUAGE_STRINGS_CHINESE,
  LANGUAGE_STRINGS_ENGLISH,
  LANGUAGE_STRINGS_THAI
} from '~/utils/api-response/settings'

export const state = () => ({
  loading: false,
  languageStrings: {},
  errorStrings: {}
})

export const actions = {
  fetchLanguageStrings({ commit }, localeLang) {
    commit('setLoading', true)
    let response = LANGUAGE_STRINGS_ENGLISH
    if (localeLang === 'th-TH') {
      response = LANGUAGE_STRINGS_THAI
    } else if (localeLang === 'zh-CN') {
      response = LANGUAGE_STRINGS_CHINESE
    }
    const convertArrayToObject = Object.fromEntries(
      response.data.map(item => [item.code, item.string])
    )
    commit('setLanguageString', convertArrayToObject)

    commit('setLoading', false)
  },
  getErrorStrings({ commit }, langCode = 'en-US') {
    let data = ERROR_CODES_ENGLISH
    if (langCode === 'th-TH') {
      data = ERROR_CODES_THAI
    } else if (langCode === 'zh-CN') {
      data = ERROR_CODES_CHINESE
    }

    commit('setErrorStrings', { data: data.data, lang: langCode })
  }
}

export const mutations = {
  setLoading: (state, v) => {
    state.loading = v
  },
  setLanguageString: (state, v) => {
    state.languageStrings = v
  },
  setErrorStrings: (state, data) => {
    const { data: errorStrings, lang } = data

    // Change array of objects to object for easier access,
    // Flatten the text object to make it easier to access
    const flattenedObject = errorStrings.reduce((acc, item) => {
      acc[item.code] = item.text[lang]
      return acc
    }, {})

    state.errorStrings = flattenedObject
  }
}

export const getters = {
  localeLanguage: state => state.languageStrings,
  tl: state => code => {
    return state.languageStrings[code] || code
  }
}
